import React from "react";
import { motion } from "framer-motion";
import { ShieldCheck } from "lucide-react";
import { HISTORY } from "./trenasData";
import TrenasLayout, { NAVY, GOLD, CREAM, SLATE } from "./TrenasLayout";

const fadeUp = { initial: { opacity: 0, y: 20 }, whileInView: { opacity: 1, y: 0 }, viewport: { once: true, margin: "-60px" }, transition: { duration: 0.5, ease: "easeOut" } };

export default function TrenasHistory() {
  return (
    <TrenasLayout active="history">
      <section className="py-16 sm:py-20" style={{ background: NAVY }}>
        <div className="max-w-3xl mx-auto px-5 sm:px-8 text-center">
          <motion.span {...fadeUp} className="text-xs uppercase tracking-[0.25em] font-semibold" style={{ color: GOLD }}>Our History</motion.span>
          <motion.h1 {...fadeUp} className="mt-4 trenas-serif text-3xl sm:text-5xl text-white">A Legacy of Legal Practice in Iloilo</motion.h1>
          <motion.p {...fadeUp} className="mt-5 text-white/75 max-w-xl mx-auto text-sm">Our own office letterhead and wall plaques trace our Iloilo lineage through several partner-name eras.</motion.p>
        </div>
      </section>

      {/* TIMELINE */}
      <section className="py-16" style={{ background: CREAM }}>
        <div className="max-w-3xl mx-auto px-5 sm:px-8">
          <div className="space-y-8">
            {HISTORY.map((h, i) => (
              <motion.div key={h.year} {...fadeUp} transition={{ ...fadeUp.transition, delay: i * 0.08 }} className="flex gap-6 items-start">
                <div className="shrink-0 w-24 text-right trenas-serif text-xl pt-0.5" style={{ color: GOLD }}>{h.year}</div>
                <div className="flex-1 border-l-2 pl-6 pb-2" style={{ borderColor: GOLD }}>
                  <h3 className="trenas-serif text-lg" style={{ color: NAVY }}>{h.title}</h3>
                  <p className="mt-1.5 text-sm" style={{ color: SLATE }}>{h.text}</p>
                </div>
              </motion.div>
            ))}
          </div>
          <motion.div {...fadeUp} className="mt-10 flex items-start gap-2.5 rounded-lg p-4 text-xs" style={{ background: "rgba(11,31,69,0.05)", color: SLATE }}>
            <ShieldCheck size={16} className="shrink-0 mt-0.5" style={{ color: GOLD }} />
            This traces our history of names in Iloilo — it doesn't claim that one unchanged partnership has operated continuously and identically since 1918.
          </motion.div>
        </div>
      </section>

      {/* HERITAGE PHOTO */}
      <section className="py-16">
        <div className="max-w-4xl mx-auto px-5 sm:px-8">
          <motion.div {...fadeUp} className="rounded-lg overflow-hidden shadow-md">
            <img src="/law/trenas-law-iloilo-concept/office-heritage-wall.jpg" alt="The firm's Iloilo office wall, showing Treñas Law Offices (1918), Treñas, Treñas & Rubias (1995), and the firm's current name" className="w-full h-auto object-cover" />
          </motion.div>
          <motion.p {...fadeUp} className="mt-3 text-xs text-center" style={{ color: SLATE }}>The firm's own office wall, Iloilo City.</motion.p>
        </div>
      </section>
    </TrenasLayout>
  );
}
